module.exports = __webpack_public_path__ + "static/media/IMAGE_6-WILDFLOWER_(GETTY)_desktop.a3b6e891.jpg";